import { memo, ReactNode } from 'react';

import { useBreakpoints } from 'hooks';

export interface IResponsiveProps {
  aboveMobile?: boolean;
  mobile?: boolean;
  children: ReactNode;
}

export const Responsive = memo<IResponsiveProps>(({ aboveMobile, mobile, children }) => {
  const { isAboveMobile, isMobile } = useBreakpoints();

  const shouldRender = (aboveMobile && isAboveMobile) || (mobile && isMobile);

  return shouldRender ? <>{children}</> : null;
});
